module.exports = __webpack_public_path__ + "static/media/gender.721ae018.svg";